import axios from "axios";
import { environment } from "../../environment";
import { DataConstant } from "../constants/data.constant";
import { getJwtToken } from "../Security/session-storage";


const publicAxioxInstance = axios.create({
    baseURL: environment.local_public_endpoint, // Your backend URL
    timeout: 5000,
});

const privateAxiosInstance = axios.create({
    baseURL: environment.local_private_endpoint, // Your backend URL
    timeout: 5000,
});


privateAxiosInstance.interceptors.request.use(
    (config) => {
        // Modify the request config here (e.g., add headers, authentication tokens)
        const accessToken = getJwtToken(DataConstant.sessionStorage.JWT_TOKEN);
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
            config.headers["Content-Type"]='application/json'
        }
        return config;
    },
    (error) => {
        // Handle request errors here
        return Promise.reject(error);
    }
);

export {
    privateAxiosInstance,
    publicAxioxInstance
}